if not App.angularApp?
    return

App.angularApp.directive 'mfValidateDependingOn', ['$parse', ($parse) ->
    return {
        require: 'ngModel'
        scope:
            mfValidateDependingOn: '='
        link: (scope, element, attrs, ngModel) =>
            # watch the other input value and revalidate when it changes
            scope.$watch 'mfValidateDependingOn.$modelValue', (value) ->
                ngModel.$setDirty(true)
                ngModel.$validate()
    }
]
